const boolenValues = [
  "confidential",
  "cancelledCheck",
  "ownerInSameGoup",
  "onlyIfOwner",
  "onlyUserCountry",
];

const getObjectLength = (object) => {
  if (typeof object !== "object") return 0;
  return Object.keys(object).length;
};

let cleanObject = function (object) {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === "object") cleanObject(v);
    if (
      (v && typeof v === "object" && !Object.keys(v).length) ||
      v === null ||
      v === undefined ||
      v.length === 0
    ) {
      if (Array.isArray(object)) object.splice(k, 1);
      else if (!(v instanceof Date)) delete object[k];
    }
  });
  return object;
};

export const getPermissionsdataforDbFromScratch = (permissions) => {
  let responseObject = {};
  // Object.keys(permissions).map((rt) => {
  for (let rt in permissions) {
    if (rt === "*") {
      responseObject[rt] = permissions[rt];
    } else {
      // rt = checkrequest
      responseObject[rt] = {};
      const currentRtObject = permissions[rt];
      for (let action in currentRtObject) {
        //action = search
        if (action === "*") {
          responseObject[rt][action] = permissions[rt][action];
        } else {
          // action = create, view, search
          if (
            typeof currentRtObject[action] === "object" &&
            currentRtObject[action]["accessStatus"] === true
          ) {
            if (
              currentRtObject[action]["conditions"] &&
              Object.keys(currentRtObject[action]["conditions"]).length > 0
            ) {
              responseObject[rt][action] = {};
              let isSelectedCountForNoConditionsAllow = 0;
              for (let cond in currentRtObject[action]["conditions"]) {
                //cond = checkTypes - AML KYC
                if (
                  currentRtObject[action]["conditions"][cond]["isSelected"] ===
                  false
                ) {
                  isSelectedCountForNoConditionsAllow++;
                }
                if (boolenValues.includes(cond)) {
                  if (currentRtObject[action]["conditions"][cond]) {
                    if (
                      currentRtObject[action]["conditions"][cond][
                        "isSelected"
                      ] === true
                    ) {
                      for (let pv of currentRtObject[action]["conditions"][
                        cond
                      ]["possibleValues"]) {
                        if (pv["isTicked"] === true) {
                          if (pv.value === "false") {
                            responseObject[rt][action][cond] = false;
                          }
                          if (pv.value === "true") {
                            responseObject[rt][action][cond] = true;
                          }
                        }
                      }
                    } else {
                      //   responseObject[rt][action][cond] = false; //confirmation needed
                    }
                  }
                } else {
                  if (
                    currentRtObject[action]["conditions"][cond][
                      "isSelected"
                    ] === true
                  ) {
                    if (
                      currentRtObject[action]["conditions"][cond][
                        "possibleValues"
                      ] &&
                      currentRtObject[action]["conditions"][cond][
                        "possibleValues"
                      ].length > 0
                    ) {
                      let resultValues = [];
                      for (let pv of currentRtObject[action]["conditions"][
                        cond
                      ]["possibleValues"]) {
                        if (pv["isTicked"] === true) {
                          resultValues.push(pv["value"]);
                        }
                      }
                      responseObject[rt][action][cond] = resultValues;
                    }
                  }
                }
              }
              // let lengthCompareFlag = Object.keys(
              //   currentRtObject[action]["conditions"]
              // ).every(
              //   (e) => !currentRtObject[action]["conditions"][e]["isSelected"]
              // );
              if (
                isSelectedCountForNoConditionsAllow ===
                Object.keys(currentRtObject[action]["conditions"]).length
              ) {
                responseObject[rt][action] = true;
              }
            }
          }

          //NEED CONFIRMATION ON THIS
          if (
            typeof currentRtObject[action] === "object" &&
            currentRtObject[action]["accessStatus"] === false &&
            ((permissions.hasOwnProperty("*") && permissions["*"] !== false) ||
              (permissions[rt].hasOwnProperty("*") &&
                permissions[rt]["*"] !== false))
          ) {
            responseObject[rt][action] = false;
          }
        }
      }
    }
  }
  const normalizedResponseObject = {};
  if (getObjectLength(responseObject) < 1) {
    normalizedResponseObject["*"] = {
      "*": false,
    };
  } else {
    const globalStatus = responseObject.hasOwnProperty("*")
      ? responseObject["*"]["*"]
      : null;
    for (let rt in responseObject) {
      if (rt === "*") {
        normalizedResponseObject["*"] = { ...responseObject["*"] };
        continue;
      }
      if (getObjectLength(responseObject[rt]) < 1) continue;
      const recordLevelStatus = responseObject[rt].hasOwnProperty("*")
        ? responseObject[rt]["*"]
        : null;

      //if all action are true
      if (
        Object.keys(responseObject[rt]).every(
          (action) =>
            typeof responseObject[rt][action] === "boolean" &&
            responseObject[rt][action] === true
        ) &&
        getObjectLength(responseObject[rt]) === getObjectLength(permissions[rt])
      ) {
        // if (
        //   recordLevelStatus !== null &&
        //   globalStatus !== null &&
        //   recordLevelStatus === globalStatus
        // ) {
        //   delete responseObject[rt];
        // }
        if (
          recordLevelStatus !== null &&
          globalStatus !== null &&
          recordLevelStatus !== globalStatus
        ) {
          normalizedResponseObject[rt] = { "*": recordLevelStatus };
        }
        if (
          recordLevelStatus === null &&
          globalStatus !== null &&
          globalStatus === false
        ) {
          normalizedResponseObject[rt] = { "*": true };
        }
        if (
          recordLevelStatus === null &&
          globalStatus !== null &&
          globalStatus === true
        ) {
          // delete responseObject[rt];
        }
        if (recordLevelStatus !== null && globalStatus === null) {
          normalizedResponseObject[rt] = { "*": recordLevelStatus };
        }
        if (recordLevelStatus === null && globalStatus === null) {
          normalizedResponseObject[rt] = { "*": true };
        }
      } else if (
        Object.keys(responseObject[rt]).every(
          (action) =>
            typeof responseObject[rt][action] === "boolean" &&
            responseObject[rt][action] === false
        ) &&
        getObjectLength(responseObject[rt]) === getObjectLength(permissions[rt])
      ) {
        if (
          recordLevelStatus !== null &&
          globalStatus !== null &&
          recordLevelStatus === globalStatus
        ) {
          // delete responseObject[rt];
        }
        if (
          recordLevelStatus !== null &&
          globalStatus !== null &&
          recordLevelStatus !== globalStatus
        ) {
          normalizedResponseObject[rt] = { "*": recordLevelStatus };
        }
        if (
          recordLevelStatus === null &&
          globalStatus !== null &&
          globalStatus === false
        ) {
          // delete responseObject[rt];
        }
        if (
          recordLevelStatus === null &&
          globalStatus !== null &&
          globalStatus === true
        ) {
          normalizedResponseObject[rt] = { "*": false };
        }
        if (recordLevelStatus !== null && globalStatus === null) {
          normalizedResponseObject[rt] = { "*": recordLevelStatus };
        }

        if (recordLevelStatus === null && globalStatus === null) {
          normalizedResponseObject[rt] = { "*": false };
        }
      } else {
        normalizedResponseObject[rt] = JSON.parse(
          JSON.stringify(responseObject[rt])
        );
      }
    }
  }
  if (
    Object.keys(normalizedResponseObject).every(
      (rt) =>
        Object.keys(normalizedResponseObject[rt]).length === 1 &&
        normalizedResponseObject[rt].hasOwnProperty("*")
    ) &&
    getObjectLength(normalizedResponseObject) === getObjectLength(permissions)
  ) {
    const finalNormalize = {};
    if (
      Object.keys(normalizedResponseObject).every(
        (rt) => normalizedResponseObject[rt]["*"] === true
      )
    ) {
      finalNormalize["*"] = { "*": true };
    }
    if (
      Object.keys(normalizedResponseObject).every(
        (rt) => normalizedResponseObject[rt]["*"] === false
      )
    ) {
      finalNormalize["*"] = { "*": false };
    }
    return finalNormalize;
  }
  if (getObjectLength(normalizedResponseObject) === 0) {
    const finalNormalize = {
      "*": {
        "*": false,
      },
    };
    return finalNormalize;
  }
  const globalPermission = normalizedResponseObject.hasOwnProperty("*")
    ? normalizedResponseObject["*"]["*"]
    : null;
  const workingFinal = JSON.parse(JSON.stringify(normalizedResponseObject));
  for (let rt in normalizedResponseObject) {
    if (rt === "*") continue;
    const recordPermission = normalizedResponseObject[rt].hasOwnProperty("*")
      ? normalizedResponseObject[rt]["*"]
      : null;
    for (let action in normalizedResponseObject[rt]) {
      if (action === "*") continue;
      if (
        typeof normalizedResponseObject[rt][action] === "boolean" &&
        (recordPermission !== null
          ? normalizedResponseObject[rt][action] === recordPermission
          : globalPermission !== null
          ? normalizedResponseObject[rt][action] === globalPermission
          : false)
      ) {
        delete workingFinal[rt][action];
      }
    }
  }
  return workingFinal;
};
